const locale = {
	PAGE_ERRORS_BACK: 'Go back to dashboard',

	PAGE_404_TITLE: 'Not found',
	PAGE_404_DESCRIPTION:
		"The page you are trying to access doesn't exist. It's possible that the url is wrong or the item has been deleted.",

	PAGE_401_TITLE: 'Not authorized',
	PAGE_401_DESCRIPTION:
		'You do not have the necessary permissions to view the page. Contact an administrator for more information.',

	PAGE_500_TITLE: 'Unhandled exception',
	PAGE_500_DESCRIPTION: 'An error has occurred in the application. Contact support for more information.'
};

export default locale;
